@if (step !== 'Signature') {
  <div class="menu-list">
    <button
      [disabled]="!disabled"
      class="menu-btn"
      mat-icon-button
      [matMenuTriggerFor]="menu"
      aria-label="Example icon-button with a menu"
    >
      <mat-icon>more_vert</mat-icon>
    </button>
    <mat-menu
      #menu="matMenu"
      (click)="$event.stopPropagation()"
      [xPosition]="'after'"
      [overlapTrigger]="false"
    >
      @if (groupedData[step]) {
        @for (q of groupedData[step]; track q; let i = $index) {
          <button
            mat-menu-item
            (click)="setQuestionStep(q)"
            [disabled]="isFirstQuestionNotValid(q, step, i)"
          >
            @if (!questionNotValid(q)) {
              <mat-icon class="green-question">done</mat-icon>
            } @else {
              <mat-icon class="red">quiz</mat-icon>
            }
            <span>{{ getQuestionTitle(q) }}</span>
          </button>
        }
      }
    </mat-menu>
  </div>
}
